/*eslint-disable */
export default announcement_bar => {
  $(window).load(()=>{
    let $mobile_nav = $('.header__mobile_nav')
    let $mobile_nav_wrapper = $('.header__mobile_nav_wrapper')
    let $body = $('body')
    let bx_pusher = false;

    $body.addClass('body-announcement-bar')
    $mobile_nav_wrapper.addClass('announcement-bar-active')

    $('.bx-pusher').length && $mobile_nav.addClass('bx-open')
    bx_pusher = true;
    $('.bx-pusher') && $('.bx-base').on("DOMSubtreeModified",function(){
      $mobile_nav.removeClass('bx-open')
      bx_pusher = false;
    });
  })
}


// WEBPACK FOOTER //
// ./src/scripts/components/announcement-bar.js